/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React, { useState } from "react";
import styled from "styled-components";
import { TabContent, Tabs, TabsItem, TabsList } from "../ui/Tabs";
import ClientLoginForm from "./ClientLoginForm";
import ClientRegisterForm from "./ClientRegisterForm";
import ClientForgotPasswordView from "../client/ClientForgotPasswordView";
import { useConfig } from "../../lib/react-query/useConfig";
import { CLIENT_LOGIN_VIEW_STATES } from "../../constants/constants";

const StyledClientAuth = styled.div`
  padding: 24px;
  border: 1px solid rgba(${({ theme }) => theme.colors.border.rgba});
  border-radius: 1rem;
`;

const ClientAuth = ({ onAuthSuccess, initialTab = "sign_in" }) => {
  const [view, setView] = useState(CLIENT_LOGIN_VIEW_STATES.LOGIN);
  const { data: config } = useConfig();
  const isRegistrationAllowed = config?.client_login_allow_registration;

  const showLogin = () => setView(CLIENT_LOGIN_VIEW_STATES.LOGIN);
  const showForgotPassword = () => setView(CLIENT_LOGIN_VIEW_STATES.FORGOT_PASSWORD);

  const renderAuthContent = () => {
    if (view === CLIENT_LOGIN_VIEW_STATES.FORGOT_PASSWORD) {
      return <ClientForgotPasswordView onLoginClick={showLogin} />;
    }

    return <ClientLoginForm onForgotPasswordClick={showForgotPassword} onSubmit={onAuthSuccess} />;
  };

  const renderWithTabs = () => (
    <Tabs defaultTab={initialTab}>
      <TabsList>
        <TabsItem title="sign_in" id="sign_in" onClick={showLogin} />
        <TabsItem title="Sign up" id="sign_up" />
      </TabsList>
      <TabContent id="sign_in">
        {renderAuthContent()}
      </TabContent>
      <TabContent id="sign_up">
        <ClientRegisterForm onSubmit={onAuthSuccess} />
      </TabContent>
    </Tabs>
  );

  return (
    <StyledClientAuth>
      {isRegistrationAllowed ? renderWithTabs() : renderAuthContent()}
    </StyledClientAuth>
  );
};

export default ClientAuth;
